import { SelectCamera } from "@/features/vidyo-devices/components/select-camera";
import { SelectMicrophone } from "@/features/vidyo-devices/components/select-microphone";
import { SelectSpeaker } from "@/features/vidyo-devices/components/select-speaker";

export function DeviceSettings() {
  return (
    <div className="flex flex-col space-y-3">
      <div>
        <p className="mb-1 text-sm text-foreground">Camera</p>
        <div className="rounded-lg border border-border">
          <SelectCamera />
        </div>
      </div>
      <div>
        <p className="mb-1 text-sm text-foreground">Microphone</p>
        <div className="rounded-lg border border-border">
          <SelectMicrophone />
        </div>
      </div>
      <div>
        <p className="mb-1 text-sm text-foreground">Speaker</p>
        <div className="rounded-lg border border-border">
          <SelectSpeaker />
        </div>
      </div>
    </div>
  );
}
